import { Component, HostListener, ElementRef  } from '@angular/core';
import { TrackTrafficService } from './services/track-traffic.service';

interface FacilityLevel {
  id: string;
  image: string;
  title: string;
  description: string;
  facilities: string[];
}

interface UnitLayout {
  id: string;
  title: string;
  bedrooms: string;
  sqft: string;
  sqm: string;
  images: string[];
  levelInfo: string;
}

interface OfficeLayout {
  id: string;
  title: string;
  sqft: string;
  sqm: string;
  images: string[];
}

interface CorporateSuite {
  title: string;
  image: string;
  subtitle: string;
  description: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'pavilionsquareklcc-ui';
  menuOpen = false;
  playVideo = false;
  
  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

    constructor(
    private trackTrafficService: TrackTrafficService,
  ) {}

  levels: FacilityLevel[] = [
    {
      id: 'Level 1',
      image: 'assets/images/level1.jpg',
      title: 'Level 1 Facilities',
      description: 'Elegant arrival experience and premium lifestyle amenities.',
      facilities: [
        'Retail            ',  
        'Lobby             ',
        'Concierge         ',
        'Waiting Lounge    ',
        'Mail Room         ',
        'Washroom          ',
        'Management Office ',
        'Security Room     ',
        'Lift Lobby        ',
        'Collection Room   '
      ]
    },

    {
      id: 'Level 12',
      image: 'assets/images/level12.jpg',
      title: 'Level 12 Facilities',
      description: 'Lifestyle facilities designed for comfort and relaxation.',
      facilities: [
              'Access to Link-bridge',
              'Water Feature and Pl',
              'Serene Trail        ',
              'The Promenade Walkwa',
              'Garden Terrace      ',
              'Yoga Deck           ',
              'Seating Courtyard   ',
              'The Retreat         ',
              'Club Lounge         ',
              'Lift Lobby          ',
              'Outdoor Lounge      ',
              'Multi-purpose Hall  ',
              'Pre-function Room   ',
              'Washroom            ',
              'Landscape Terrace   ',
              'Karaoke Room*       ',
              'Foosball Table      ',
              'Pool Table          ',
              'Entertainment Room  ',
              'Mahjong Room        ',
              'Snooker Table       ',
              'Lounge Area         ',
              'BBQ Deck            ',
              'Operation Office*   ',
              'Laundromat*         ',
              'Indoor Kids Room    ',
              'Kids Playground     ',
              'Surau               '
      ]
    },

    {
      id: 'Level 63A',
      image: 'assets/images/level63a.jpg',
      title: 'Level 63A Facilities',
      description: 'Sky-level recreational amenities.',
      facilities: [
        'Outdoor Yoga Deck                         ',
        'Gymnasium (Cardio & Strength Training)    ',
        'Lift Lobby                                ',
        'Sports Lounge                             ',
        'Outdoor Lounge                            ',
        'Washroom                                  ',
        'Lockers                                   ',
        'Sauna                                     ',
        'Steam Room                                ',
        'Changing Room                             ',
        'Gymnasium (Functional Training)           ',
        'Facilities Lift (Level 66 & 67)           ',
        'Gymnasium (Cardio & Functional Training)  ',
        'Outdoor Gymnasium                         '									   
      ]
    },

    {
      id: 'Level 66',
      image: 'assets/images/level66.jpg',
      title: 'Level 66 Facilities',
      description: 'Luxury wellness facilities.',
      facilities: [
        'Co-working Lounge               ',
        'Indoor Lounge                   ',
        'Reading Court                   ',
        'Sunken Plaza and Viewing Deck   ',
        'Facilities Lift (Level 66 & 67) ',
        'Washroom                        ',
        'Sky Plaza                       ',
        'Spiral Staircase                '
      ]
    },

    {
      id: 'Level 67',
      image: 'assets/images/level67.jpg',
      title: 'Level 67 Facilities',
      description: 'Exclusive rooftop experiences.',
      facilities: [
        'Infinity Pool                  ',
        'Kids Pool                      ',
        'Table and Seating Area         ',
        'Wading Pool/Jacuzzi            ',
        'Pool Deck                      ',
        'Outdoor Shower                 ',
        'Sun Loungers                   ',
        'Facilities Lift (Level 66 & 67)',
        'Spiral Staircase               '
      ]
    }
  ];

  selectedLevel = this.levels[0];
  selectLevel(level: FacilityLevel): void {
    this.selectedLevel = level;
  }

  unitTypes: UnitLayout[] = [
  {
    id: 'Type A',
    title: 'Type A',
    bedrooms: 'Studio',
    sqft: '504',
    sqm: '46.8',
    images: [
      'assets/images/typeA.jpg',
      'assets/images/typeAA.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type B1',
    title: 'Type B1',
    bedrooms: '1 Bedroom + Study',
    sqft: '770',
    sqm: '71.5',
    images: [
      'assets/images/typeB1.jpg',
      'assets/images/typeBB1.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type B2',
    title: 'Type B2',
    bedrooms: '1 Bedroom + Study',
    sqft: '772',
    sqm: '71.7',
    images: [
      'assets/images/typeB2.jpg',
      'assets/images/typeBB2.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type C1',
    title: 'Type C1',
    bedrooms: '2 Bedrooms',
    sqft: '966',
    sqm: '89.7',
    images: [
      'assets/images/typeC1.jpg',
      'assets/images/typeCC1.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type C2',
    title: 'Type C2',
    bedrooms: '2 Bedrooms + Study',
    sqft: '978',
    sqm: '90.9',
    images: [
      'assets/images/typeC2.jpg',
      'assets/images/typeCC2.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type C3',
    title: 'Type C3',
    bedrooms: '2 Bedrooms + Study',
    sqft: '1,100',
    sqm: '102.2',
    images: [
      'assets/images/typeC3.jpg',
      'assets/images/typeCC3.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type C4',
    title: 'Type C4',
    bedrooms: '2 Bedrooms + Study',
    sqft: '1,272',
    sqm: '118.2',
    images: [
      'assets/images/typeC4.jpg',
      'assets/images/typeCC4.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  },
  {
    id: 'Type D',
    title: 'Type D',
    bedrooms: '3 Bedrooms',
    sqft: '1,255',
    sqm: '116.6',
    images: [
      'assets/images/typeD.jpg',
      'assets/images/typeDD.jpg'
    ],
    levelInfo: '13A–37 & 39–62',
  }
];

  selectedImage = '';
  currentImageIndex = 0;
  selectedUnit: UnitLayout = this.unitTypes[0];
  
  selectUnit(unit: UnitLayout) {
    this.selectedUnit = unit;

    this.currentImageIndex = 0;
    this.selectedImage =
      unit.images[0];
  }

  setImage(image: string, index: number) {
    this.selectedImage = image;
    this.currentImageIndex = index;
  }
  
  nextImage() {
    this.currentImageIndex++;
    if (
      this.currentImageIndex >=
      this.selectedUnit.images.length
    ) {
      this.currentImageIndex = 0;
    }
  
    this.selectedImage =
      this.selectedUnit.images[
        this.currentImageIndex
      ];
  }

  previousImage() {
    this.currentImageIndex--;
    if (this.currentImageIndex < 0) {
  
      this.currentImageIndex =
        this.selectedUnit.images.length - 1;
    }
    this.selectedImage =
      this.selectedUnit.images[
        this.currentImageIndex
      ];
  }

  corporateSuites: CorporateSuite[] = [
  {
    title: '106',
    subtitle: 'Units',
    image: 'assets/images/corporate-suite-1.jpg',
    description: 'Premium office suites designed for modern businesses.'
  },
    {
    title: '25',
    subtitle: 'Stories',
    image: 'assets/images/corporate-suite-3.jpg',
    description: 'Strategically located retail spaces.'
  },
  {
    title: 'Strata Offices',
    subtitle: 'Office Spaces',
    image: 'assets/images/corporate-suite-2.jpg',
    description: 'Ranging from 1,093 sq.ft. to 2,464 sq.ft.'
  }
];

  luxuryResidences: CorporateSuite[] = [
  {
    title: '960',
    subtitle: 'Units',
    image: 'assets/images/corporate-suite-1.jpg',
    description: 'Premium office suites designed for modern businesses.'
  },
    {
    title: '67',
    subtitle: 'Stories',
    image: 'assets/images/corporate-suite-3.jpg',
    description: 'Strategically located retail spaces.'
  },
  {
    title: 'Luxury Residences',
    subtitle: 'Studio to Family Suites',
    image: 'assets/images/lobby.jpg',
    description: 'Ranging from cosy 504 sq.ft. studios to practical 1,272 sq.ft. suites'
  }
];
  
  ngOnInit(): void {
    this.checkReveal();
    this.selectedUnit = this.unitTypes[0];
    this.selectedImage = this.selectedUnit.images[0];
    this.selectedOfficeImage = this.selectedOffice.images[0];
    this.filteredImages = this.allImages.map(i => i.src);

    // Call backend API in background to send email.
    this.trackTrafficService.trackTraffic()
      .subscribe({
        next: (response) => {
          console.log('Tracking success', response);
        },
        error: (error) => {
          console.error('Tracking failed', error);
        }
      });
  }
  
  @HostListener('window:scroll')
  onScroll() {
    this.checkReveal();
  }

  checkReveal() {
    const elements = document.querySelectorAll('.reveal');
    const windowHeight = window.innerHeight;

    elements.forEach((el: any) => {
      const position = el.getBoundingClientRect().top;

      if (position < windowHeight - 100) {
        el.classList.add('active');
      }
    });
  }

  openGoogleMap(): void {
    window.open(
      'https://maps.google.com/?q=Pavilion+Square+Kuala+Lumpur',
      '_blank'
    );
  }

  activeIndex = 0;
  features = [
  {
    title: 'Direct Bridge to Premier Shopping Destination',
    description: 'Direct access to Pavilion Kuala Lumpur, connecting you seamlessly to world-class shopping, dining and lifestyle experiences.',
    image: 'assets/images/feature1.jpg'
  },
  {
    title: 'A Grand Entrance Experience at Pavilion Square',
    description: 'An iconic entrance that reflects sophistication, accessibility and the premium identity of Pavilion Square.',
    image: 'assets/images/feature2.jpg'
  },
  {
    title: 'The Elegant Reception Lobby of Pavilion Square',
    description: 'A sophisticated arrival space designed with premium interiors, creating a welcoming atmosphere for visitors, businesses and guests.',
    image: 'assets/images/feature3.jpg'
  },
  {
    title: 'Premium Drop-Off Experience',
    description: 'A thoughtfully designed drop-off area offering convenience, comfort and a smooth arrival experience for residents and visitors.',
    image: 'assets/images/drop-off.jpg'
  },
  {
    title: 'Majestic Lobby Experience',
    description: 'A beautifully crafted lobby featuring elegant design elements and a welcoming ambience that creates a lasting first impression.',
    image: 'assets/images/majestic-lobby.jpg'
  },
  {
    title: 'Landscaped Garden Retreat',
    description: 'A serene green environment designed to provide relaxation, balance and a refreshing escape within the development.',
    image: 'assets/images/garden.jpg'
  },
  {
    title: 'Exclusive 118m Sky Pool',
    description: 'Enjoy a premium leisure experience with a stunning sky pool offering relaxation with breathtaking views.',
    image: 'assets/images/skypool.jpg'
  },
  {
    title: 'Infinity Pool with Skyline Views',
    description: 'A luxurious infinity pool designed for relaxation, featuring an elevated lifestyle experience surrounded by panoramic views.',
    image: 'assets/images/infinitypool.jpg'
  },
  {
    title: 'Elevated Sky Garden',
    description: 'A peaceful rooftop garden space blending nature and modern living, creating a refreshing environment above the city.',
    image: 'assets/images/skygarden.jpg'
  },
  {
    title: 'Awesome 15,000 sq.ft. Fitness Gym',
    description: 'A fully equipped fitness facility designed to support an active lifestyle with modern workout amenities.',
    image: 'assets/images/gym.jpg'
  }
 ];

  selectFeature(index: number) {
    this.activeIndex = index;
  }

  officeTypes: OfficeLayout[] = [
  {
    id: 'Office 1',
    title: 'OFFICE 1',
    sqft: '2,464',
    sqm: '228.9',
    images: [
      'assets/images/office1.jpg',
      'assets/images/office11.jpg'
    ],
  },
  {
    id: 'Office 2',
    title: 'OFFICE 2',
    sqft: '1,112',
    sqm: '103.3',
    images: [
      'assets/images/office2.jpg',
      'assets/images/office22.jpg'
    ],
  },
  {
    id: 'Office 3',
    title: 'OFFICE 3',
    sqft: '1,481',
    sqm: '137.6',
    images: [
      'assets/images/office3.jpg',
      'assets/images/office33.jpg'
    ],
  },
  {
    id: 'Office 3A',
    title: 'OFFICE 3A',
    sqft: '1,093',
    sqm: '101.5',
    images: [
      'assets/images/office3A.jpg',
      'assets/images/office3AA.jpg'
    ],
  },
  {
    id: 'Office 5',
    title: 'OFFICE 5',
    sqft: '1,795',
    sqm: '166.8',
    images: [
      'assets/images/office5.jpg',
      'assets/images/office55.jpg'
    ],
  },
  {
    id: 'Office 5A',
    title: 'OFFICE 5A',
    sqft: '1,668',
    sqm: '155.0',
    images: [
      'assets/images/office5A.jpg',
      'assets/images/office5AA.jpg'
    ],
  },
  {
    id: 'Office 5B',
    title: 'OFFICE 5B',
    sqft: '1,426',
    sqm: '132.5',
    images: [
      'assets/images/office5B.jpg',
      'assets/images/office5BB.jpg'
    ],
  },
  {
    id: 'Penthouse',
    title: 'PENTHOUSE',
    sqft: '9,770',
    sqm: '907.7',
    images: [
      'assets/images/penthouse.jpg',
      'assets/images/penthouseB.jpg'
    ],
  }
 ];

  selectedOfficeImage = '';
  currentOfficeImageIndex = 0;
  selectedOffice: OfficeLayout = this.officeTypes[0];
  
  selectOffice(office: OfficeLayout) {
    this.selectedOffice = office;

    this.currentOfficeImageIndex = 0;
    this.selectedOfficeImage =
      office.images[0];
  }

  setOfficeImage(image: string, index: number) {
    this.selectedOfficeImage = image;
    this.currentOfficeImageIndex = index;
  }
  
  nextOfficeImage() {
    this.currentOfficeImageIndex++;
    if (
      this.currentOfficeImageIndex >=
      this.selectedOffice.images.length
    ) {
      this.currentOfficeImageIndex = 0;
    }
  
    this.selectedOfficeImage =
      this.selectedOffice.images[
        this.currentOfficeImageIndex
      ];
  }

  previousOfficeImage() {
    this.currentOfficeImageIndex--;
    if (this.currentOfficeImageIndex < 0) {
  
      this.currentOfficeImageIndex =
        this.selectedOffice.images.length - 1;
    }
    this.selectedOfficeImage =
      this.selectedOffice.images[
        this.currentOfficeImageIndex
      ];
  }

  scrollTo(element: HTMLElement) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

    categories: string[] = [
    'All',
    'Drop-Off',
    'Lobby',
    'Garden',
    'Sky Pool',
    'Infinity Pool',
    'Sky Garden',
    'Gym'
  ];

  isImageModalOpen = false;
  modalImage = '';

  selectedCategory: string = 'All';

  featuredImage: string = 'assets/images/hero-bg-night.jpg';

  allImages: any[] = [
    { src: 'assets/images/drop-off.jpg', category: 'Drop-Off' },
    { src: 'assets/images/majestic-lobby.jpg', category: 'Lobby' },
    { src: 'assets/images/garden.jpg', category: 'Garden' },
    { src: 'assets/images/skypool.jpg', category: 'Sky Pool' },
    { src: 'assets/images/infinitypool.jpg', category: 'Infinity Pool' },
    { src: 'assets/images/skygarden.jpg', category: 'Sky Garden' },
    { src: 'assets/images/gym.jpg', category: 'Gym' },
  ];

  filteredImages: string[] = [];

    selectCategory(cat: string) {
    this.selectedCategory = cat;

    if (cat === 'All') {
      this.filteredImages = this.allImages.map(i => i.src);
    } else {
      this.filteredImages = this.allImages
        .filter(i => i.category === cat)
        .map(i => i.src);
    }
  }

  openImage(img: string) {
    this.modalImage = img;
    this.isImageModalOpen = true;
  }
  
  closeImageModal() {
    this.isImageModalOpen = false;
    this.modalImage = '';
  }

  viewAll() {
    this.selectedCategory = 'All';
    this.filteredImages = this.allImages.map(i => i.src);
  }

  openWhatsApp(): void {
    const message = 'Hi Sue Malli, I am interested to schedule a viewing for Pavilion Square.';
    const url = 'https://wa.me/60123815970?text=' +  encodeURIComponent(message);
    window.open(url, '_blank');
  }

  prevFeature(): void {
  this.activeIndex =
    this.activeIndex === 0
      ? this.features.length - 1
      : this.activeIndex - 1;
  }
  
  nextFeature(): void {
    this.activeIndex =
      this.activeIndex === this.features.length - 1
        ? 0
        : this.activeIndex + 1;
  }
}
